/* My Custom Idea motion layer, built on Motion (assets/mci-motion-lib.js, motion@13.4.6, MIT).
   Loaded before mci-animations.js. Everything here is an enhancement: with reduced motion, in the theme
   editor, or without Motion, it does nothing and the CSS reveal in mci-animations.js still works.
   Only transform and opacity are animated. */
(function () {
  var M = window.Motion;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  // Marquee pause button works regardless of Motion.
  function initMarquee(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-mci-marquee]:not([data-mci-ready])'), function (band) {
      band.setAttribute('data-mci-ready', '');
      var btn = band.querySelector('[data-mci-marquee-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var paused = band.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play scrolling text' : 'Pause scrolling text');
      });
    });
  }

  // Header shadow once the page is scrolled.
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      document.documentElement.classList.toggle('mci-scrolled', window.scrollY > 8);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if (!M || reduce || designMode) {
    initMarquee(document);
    document.addEventListener('shopify:section:load', function (e) { initMarquee(e.target || document); });
    return;
  }
  document.documentElement.classList.add('mci-motion');

  var animate = M.animate;
  var inView = M.inView;
  var scroll = M.scroll;
  var spring = { type: 'spring', bounce: 0.18, visualDuration: 0.7 };

  // 1. Scroll reveals: springy rise with a stagger between siblings.
  function initReveal(root) {
    var els = root.querySelectorAll('[data-mci-reveal]:not([data-mci-seen])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-mci-seen', '');
      var i = 0;
      for (var s = el.previousElementSibling; s && i < 5; s = s.previousElementSibling) if (s.hasAttribute('data-mci-reveal')) i++;
      inView(el, function () {
        animate(el, { opacity: [0, 1], y: [28, 0] }, Object.assign({ delay: i * 0.09 }, spring)).then(function () {
          el.classList.add('is-in');
        });
      }, { amount: 0.12, margin: '0px 0px -6% 0px' });
    });
  }

  // 2. Photos settle in (scale only) as they come into view.
  function initPhotos(root) {
    var imgs = root.querySelectorAll('.mci-gallery__grid img, .mci-ccard__media img, .mci-story__photo, .mci-story__photo2, .mci-post__media img, .mci-pv__stage img');
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.hasAttribute('data-mci-photo')) return;
      img.setAttribute('data-mci-photo', '');
      inView(img, function () {
        animate(img, { scale: [1.14, 1] }, { duration: 1.4, ease: [0.2, 0.7, 0.2, 1] });
      }, { amount: 0.15 });
    });
  }

  // 3. Parallax on scroll: [data-mci-parallax="speed"], speed is a share of the element height.
  function initParallax(root) {
    var els = root.querySelectorAll('[data-mci-parallax]:not([data-mci-px])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-mci-px', '');
      var speed = parseFloat(el.getAttribute('data-mci-parallax')) || 0;
      if (!speed) return;
      var range = Math.round(window.innerHeight * speed * 0.5);
      scroll(animate(el, { y: [-range, range] }, { ease: 'linear' }), { target: el.closest('[data-mci-hero]') || el, offset: ['start end', 'end start'] });
    });
  }

  // 4. Hero: layers follow the pointer, each by its own depth.
  function initHeroPointer(root) {
    if (!finePointer) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-mci-hero-art]:not([data-mci-hp])'), function (art) {
      art.setAttribute('data-mci-hp', '');
      var layers = art.querySelectorAll('[data-mci-depth]');
      var hero = art.closest('[data-mci-hero]') || art;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        Array.prototype.forEach.call(layers, function (l) {
          var d = parseFloat(l.getAttribute('data-mci-depth')) || 10;
          animate(l, { x: -x * d, y: -y * d }, { type: 'spring', stiffness: 120, damping: 20 });
        });
      });
      hero.addEventListener('pointerleave', function () {
        Array.prototype.forEach.call(layers, function (l) { animate(l, { x: 0, y: 0 }, { type: 'spring', stiffness: 90, damping: 18 }); });
      });
    });
  }

  // 5. Cards tilt toward the pointer.
  function initTilt(root) {
    if (!finePointer) return;
    Array.prototype.forEach.call(root.querySelectorAll('.mci-card, .mci-ccard, .mci-post'), function (card) {
      if (card.hasAttribute('data-mci-tilt')) return;
      card.setAttribute('data-mci-tilt', '');
      var media = card.querySelector('.mci-card__media, .mci-ccard__media, .mci-post__media');
      if (!media) return;
      media.style.transformPerspective = '900px';
      card.addEventListener('pointermove', function (e) {
        var r = media.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        animate(media, { rotateY: x * 7, rotateX: -y * 7, y: -6 }, { type: 'spring', stiffness: 220, damping: 22 });
      });
      card.addEventListener('pointerleave', function () {
        animate(media, { rotateY: 0, rotateX: 0, y: 0 }, { type: 'spring', stiffness: 160, damping: 18 });
      });
    });
  }

  // 6. Buttons lean toward the pointer.
  function initMagnetic(root) {
    if (!finePointer) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-mci-magnetic], .mci-cta .mci-btn, .mci-story .mci-btn'), function (btn) {
      if (btn.hasAttribute('data-mci-mag')) return;
      btn.setAttribute('data-mci-mag', '');
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        animate(btn, { x: (e.clientX - r.left - r.width / 2) * 0.18, y: (e.clientY - r.top - r.height / 2) * 0.3 }, { type: 'spring', stiffness: 260, damping: 18 });
      });
      btn.addEventListener('pointerleave', function () { animate(btn, { x: 0, y: 0 }, { type: 'spring', stiffness: 200, damping: 14 }); });
    });
  }

  function init(root) {
    root = root || document;
    initMarquee(root);
    initReveal(root);
    initPhotos(root);
    initParallax(root);
    initHeroPointer(root);
    initTilt(root);
    initMagnetic(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
